import { useCallback, useState } from 'react';

import {
    COOKIE_CONSENT_VALUES,
    dismissCookieBannerForSession,
    getCookieConsent,
    isCookieBannerDismissedThisSession,
    setCookieConsent,
} from '../utils/cookieConsentStorage';

function shouldShowBanner() {
    return getCookieConsent() === null && !isCookieBannerDismissedThisSession();
}

/**
 * Drives the cookie banner: visible until a choice is stored or the X was
 * clicked in this tab session. Only the choice is recorded; no tracker is
 * gated on it (FullStory keeps running either way).
 */
export function useCookieConsent() {
    const [visible, setVisible] = useState(shouldShowBanner);

    const accept = useCallback(() => {
        setCookieConsent(COOKIE_CONSENT_VALUES.ACCEPT);
        setVisible(false);
    }, []);

    const reject = useCallback(() => {
        setCookieConsent(COOKIE_CONSENT_VALUES.REJECT);
        setVisible(false);
    }, []);

    const dismiss = useCallback(() => {
        dismissCookieBannerForSession();
        setVisible(false);
    }, []);

    return { visible, accept, reject, dismiss };
}
